import { render, staticRenderFns } from "./printed.vue?vue&type=template&id=2c363e79&scoped=true"
import script from "./printed.vue?vue&type=script&lang=js"
export * from "./printed.vue?vue&type=script&lang=js"
import style0 from "./printed.vue?vue&type=style&index=0&id=2c363e79&prod&lang=stylus&scoped=true"
import style1 from "./printed.vue?vue&type=style&index=1&id=2c363e79&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c363e79",
  null
  
)

export default component.exports